import type { PropsWithChildren } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSupportTenant } from './support-tenant-context';
import { DeferredActionProvider } from './deferred-action-provider';

/** Cancels pending actions when authentication or the assumed tenant changes. */
export const SessionDeferredActionProvider = ({
  children,
}: PropsWithChildren) => {
  const { user, isAuthenticated } = useAuth0();
  const { assumedTenantId } = useSupportTenant();
  return (
    <DeferredActionProvider
      key={`${isAuthenticated}:${user?.sub}:${assumedTenantId}`}
    >
      {children}
    </DeferredActionProvider>
  );
};
